import React, { useState, useEffect } from "react";
import "./style.scss";
import {
  Layout,
  Image,
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  Radio,
  Upload,
  Button,
  Spin,
} from "antd";
import moment from "moment";
import "moment/locale/vi";

import {
  MdCastForEducation,
  MdDateRange,
  MdOutlineLanguage,
} from "react-icons/md";
import { FaUser, FaPhone, FaFacebook, FaUpload } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { AiFillEnvironment } from "react-icons/ai";

import {
  url_get_infor_input,
  url_get_list_city,
  url_get_list_district,
  url_post_check_form_cv,
  url_post_form_create_cv,
} from "../../../constants";
import { authAxios } from "../../../utils";
import Cookies from "universal-cookie";
import { openNotificationWithIcon } from "../../Function";
import dayjs from "dayjs";
import FormSuccess from "./FormSuccess";
import FormError from "./FormError";

const cookies = new Cookies();
const { Option } = Select;

moment.locale("vi");

const { Header, Content, Footer, Sider } = Layout;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const LogoImage = () => {
  return (
    <Image
      src={`${process.env.PUBLIC_URL}/logo_new/Rainscales-logo-color.svg`}
      preview={false}
      // style={{ display: "block" }}
      className="logo-create-cv"
    />
  );
};

const Gender = [
  {
    id: 1,
    value: "Nam",
  },
  {
    id: 2,
    value: "Nữ",
  },
];

const MSG_Error = "Vui lòng thử lại sau!!!";

const index = () => {
  const [form] = Form.useForm();
  const [listCity, setListCity] = useState([]);
  const [valueCity, setValueCity] = useState(undefined);
  const [selectedFileOtherList, setSelectedFileOtherList] = useState([]);
  const [valueGender, setValueGender] = useState(undefined);
  const [listEducationLevel, setListEducationLevel] = useState([]);
  const [listCandidateSource, setListCandidateSource] = useState([]);
  const [isCheckStatusSuccess, setIsCheckStatusSuccess] = useState(false);
  const [isCheckStatusError, setIsCheckStatusError] = useState(false);
  const [listLanguageSkill, setListLanguageSkill] = useState([]);
  const [listDistrict, setListDistrict] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(undefined);
  const [msgError, setMsgError] = useState(MSG_Error);
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    const FormData = require("form-data");
    const data = new FormData();
    const currentUrl = window.location.href;

    data.append("link_cv", currentUrl);
    data.append("file_upload", selectedFileOtherList[0].originFileObj);
    data.append("city_code", values.city_code);
    data.append("district_code", values.district_code);
    data.append("address", values.address);
    data.append("first_name", values.first_name);
    data.append("birthday", dayjs(values.birthday).format("YYYY-MM-DD"));
    data.append("numberphone", values.numberphone);
    data.append("gender", values.gender);
    data.append("email", values.email);
    data.append(
      "application_date",
      dayjs(values.application_date).format("YYYY-MM-DD")
    );
    data.append("education_level", values.education_level);
    data.append("candidate_source", values.candidate_source);
    data.append("education_major", values.education_major);
    data.append("language_skill", values.language_skill);
    data.append("note", "");
    data.append("skype_facebook", values.skype_facebook);
    return authAxios(cookies.get("token"))
      .post(url_post_form_create_cv, data)
      .then((res) => {
        setIsCheckStatusSuccess(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("error_code")) {
            if (err.data.error_code.includes("ticket-1001")) {
              setIsCheckStatusError(true);
              setMsgError(err.data.message);
              return;
            }
          }
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
      });
  };

  const disabledDate = (current) => {
    const eighteenYearsAgo = moment().subtract(18, "years");
    // Chỉ cho phép chọn ngày nhỏ hơn hoặc bằng ngày 18 năm trước
    return current && current > eighteenYearsAgo.endOf("day");
  };

  const fetchListCity = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(url_get_list_city, { params: params })
      .then((res) => {
        setListCity(res.data);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
      });
  };

  const fetchInforInput = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(url_get_infor_input, { params: params })
      .then((res) => {
        setListEducationLevel(res.data.list_education_level);
        setListCandidateSource(res.data.list_candidate_source);
        setListLanguageSkill(res.data.ls_language_skill);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
      });
  };

  const fetchListDistrict = (params = {}) => {
    if (params.city_code != null) {
      authAxios(cookies.get("token"))
        .get(url_get_list_district, { params: params })
        .then((res) => {
          setListDistrict([]);
          setListDistrict(res.data);
        })
        .catch((err) => {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              window.location = "/login";
            }
          }
          console.log(err);
          // openNotificationWithIcon('success','Thành công','');
        });
    }
  };

  const handleChangeCity = (e) => {
    setSelectedDistrict(undefined);
    form.setFieldsValue({
      district_code: undefined,
    });

    if (e == undefined) {
      setListDistrict([]);
    } else {
      setValueCity(e);
      fetchListDistrict({ city_code: e });
    }
  };

  const postCheckFormCV = (values) => {
    setLoading(true);
    const FormData = require("form-data");
    const data = new FormData();
    const currentUrl = window.location.href;

    data.append("link_cv", currentUrl);
    return authAxios(cookies.get("token"))
      .post(url_post_check_form_cv, data)
      .then((res) => {
        fetchListCity();
        fetchInforInput();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("error_code")) {
            if (err.data.error_code.includes("ticket-1001")) {
              setIsCheckStatusError(true);
              setMsgError(err.data.message);
              return;
            }
          }
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
        setIsCheckStatusError(true);
        setMsgError(MSG_Error);
      });
  };

  useEffect(() => {
    postCheckFormCV();
  }, []);

  const screenHeight = window.innerWidth;

  const handleChangeOther = (info) => {
    let thisFileList = info.fileList;

    if (thisFileList.status === "removed") {
      setSelectedFileOtherList([]);
      form.setFieldsValue({
        upload_file: undefined,
      });
      return;
    }

    if (
      thisFileList[0].type === "application/pdf" ||
      thisFileList[0].type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      setSelectedFileOtherList(thisFileList);
    } else {
      setSelectedFileOtherList([]);
      openNotificationWithIcon(
        "error",
        "Cảnh báo",
        "Vui lòng chọn tệp .docx hoặc pdf hợp lệ."
      );
    }
  };

  const eighteenYearsAgo = moment().subtract(18, "years");

  const handleChangeGender = (value) => {
    setValueGender(value);
  };

  return (
    <>
      <div className="header-logo-create-cv">
        <LogoImage />
      </div>

      <Spin spinning={loading}>
        {loading === false &&
          isCheckStatusSuccess === false &&
          isCheckStatusError === false && (
            <div
              className="container-create-cv"
              data-screen-height-2560={screenHeight < 2560}
              data-screen-height-1700={screenHeight < 1700}
              data-screen-height-1440={screenHeight < 1440}
            >
              <Row>
                <Col span={24}>
                  <h1
                    style={{
                      fontSize: 30,
                      fontWeight: 800,
                      textAlign: "center",
                    }}
                  >
                    THÔNG TIN ỨNG TUYỂN
                  </h1>
                </Col>
              </Row>

              <Form
                form={form}
                layout="vertical"
                autoComplete="off"
                initialValues={{ remember: true }}
                onFinish={onFinish}
              >
                <Row className="body-row-create-cv">
                  <Col span={8} className="first-name-right-input-create-cv">
                    <Row>
                      <Col span={24}>
                        <Form.Item
                          name="first_name"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập họ tên!",
                            },
                            {
                              pattern:
                                /^[a-zA-ZÀ-ỹ0-9]+(?:\s[a-zA-ZÀ-ỹ0-9]+)*$/,
                              message:
                                "Họ và Tên có khoảng trắng bị thừa / sai định dạng!",
                            },
                            {
                              min: 3,
                              message: "Họ và Tên phải có ít nhất 3 ký tự!",
                            },
                          ]}
                          wrapperCol={{ span: 22 }}
                        >
                          <Input
                            className="first-name-input-create-cv"
                            placeholder="Nguyễn Văn A"
                          />
                        </Form.Item>
                      </Col>
                      {/* <Col span={24}>
                    <Form.Item
                      name="education_major"
                      rules={[
                        {
                          required: true,
                          message: "Vui lòng nhập chuyên ngành!",
                        },
                      ]}
                      wrapperCol={{ span: 22 }}
                    >
                      <Input
                        className="input-right-create-cv"
                        placeholder="Kỹ sư phần mềm"
                      />
                    </Form.Item>
                  </Col> */}
                    </Row>
                  </Col>
                  <Col span={16}>
                    <Row style={{ marginLeft: 10 }}>
                      <Col span={24} className="form-item-col-create-cv">
                        <Form.Item
                          label={<FaUser className="icon-right-create-cv" />}
                          name="gender"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn giới tính",
                            },
                          ]}
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 8 }}
                        >
                          <Select
                            suffixIcon={null}
                            className="select-right-create-cv"
                            onChange={handleChangeGender}
                            value={valueGender}
                            optionFilterProp="children"
                            placeholder="Giới tính"
                            style={{ fontSize: 16 }}
                          >
                            {Gender.map((e, index) => (
                              <Option key={e.id} value={e.value}>
                                {e.value}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={24} className="form-item-col-create-cv">
                        <Form.Item
                          label={
                            <MdDateRange className="icon-right-create-cv" />
                          }
                          name="birthday"
                          key="birthday"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn ngày sinh!",
                            },
                          ]}
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 8 }}
                        >
                          <DatePicker
                            suffixIcon={null}
                            placeholder="Ngày sinh"
                            className="date-picker-right-create-cv"
                            clearIcon
                            format={"DD/MM/YYYY"}
                            disabledDate={disabledDate}
                            defaultPickerValue={eighteenYearsAgo}
                            showToday={false}
                            // onChange={onChange}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} className="form-item-col-create-cv">
                        <Form.Item
                          label={<FaPhone className="icon-right-create-cv" />}
                          name="numberphone"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập số điện thoại!",
                            },
                            {
                              pattern: /^\d+$/,
                              message: "Số điện thoại chỉ được nhập bằng số",
                            },
                          ]}
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 8 }}
                        >
                          <Input
                            placeholder="0123456789"
                            className="input-right-create-cv"
                            maxLength={12}
                            minLength={10}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} className="form-item-col-create-cv">
                        <Form.Item
                          label={<IoMdMail className="icon-right-create-cv" />}
                          name="email"
                          rules={[
                            {
                              type: "email",
                              message: "Vui lòng nhập đúng định dạng E-mail!",
                            },
                            {
                              required: true,
                              message: "Vui lòng nhập email!",
                            },
                          ]}
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 22 }}
                        >
                          <Input
                            placeholder="hr@rainscales.com"
                            className="input-right-create-cv"
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        span={12}
                        className="form-item-col-create-cv"
                        // style={{ display: "flex" }}
                      >
                        <Form.Item
                          label={
                            <AiFillEnvironment className="icon-right-create-cv" />
                          }
                          name="address"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập địa chỉ!",
                            },
                            {
                              pattern:
                                /^[a-zA-ZÀ-ỹ0-9,.\-/]+(?:\s[a-zA-ZÀ-ỹ0-9,.\-/]+)*$/,
                              message:
                                "Địa chỉ không hợp lệ! Hãy kiểm tra lại.",
                            },
                            {
                              min: 5,
                              message: "Địa chỉ phải có ít nhất 5 ký tự!",
                            },
                          ]}
                          labelCol={{ span: 4 }}
                          wrapperCol={{ span: 19 }}
                        >
                          <Input
                            placeholder="158 Xô Viết Nghệ Tĩnh"
                            className="input-right-create-cv"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="city_code"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn Tỉnh/Thành phố!",
                            },
                          ]}
                        >
                          <Select
                            onChange={handleChangeCity}
                            allowClear={true}
                            suffixIcon={null}
                            className="select-address-right-create-cv"
                            placeholder="Tỉnh/Thành phố"
                            showSearch={true}
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {listCity.map((city) => (
                              <Select.Option key={city.code} value={city.code}>
                                {city.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="district_code"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn Quận/Huyện!",
                            },
                          ]}
                        >
                          <Select
                            onChange={setSelectedDistrict}
                            value={selectedDistrict}
                            allowClear={true}
                            suffixIcon={null}
                            className="select-address-right-create-cv"
                            placeholder="Quận/Huyện"
                            showSearch={true}
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {listDistrict != undefined &&
                              listDistrict.map((district) => (
                                <Select.Option
                                  key={district.code}
                                  value={district.code}
                                >
                                  {district.name}
                                </Select.Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={24} className="form-item-col-create-cv">
                        <Form.Item
                          label={
                            <FaFacebook className="icon-right-create-cv" />
                          }
                          name="skype_facebook"
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 22 }}
                        >
                          <Input
                            placeholder="Skype/Facebook"
                            className="input-right-create-cv"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12} style={{ marginTop: 20 }}>
                    <Row style={{ display: "flex" }}>
                      <Col span={4}>
                        <p
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            margin: "auto",
                          }}
                        >
                          HỌC VẤN
                        </p>
                        <div
                          style={{
                            background: "black",
                            width: "80%",
                            height: 5,
                          }}
                        ></div>
                      </Col>
                      <Col span={19} style={{ margin: "auto" }}>
                        <div
                          style={{
                            background: "black",
                            width: "100%",
                            height: 2,
                          }}
                        ></div>
                      </Col>
                      <Col span={23}>
                        <Form.Item
                          name="education_level"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn trình độ học vấn!",
                            },
                          ]}
                          wrapperCol={{ span: 24 }}
                        >
                          <Radio.Group
                            // onChange={onChange}
                            // value={value}
                            style={{ marginTop: 10, width: "100%" }}
                          >
                            {listEducationLevel.map((item, index) => (
                              <Radio value={item.id}>
                                <p style={{ fontSize: 16 }}>{item.name}</p>
                              </Radio>
                            ))}
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12} style={{ marginTop: 20 }}>
                    <Row style={{ display: "flex" }}>
                      <Col span={7}>
                        <p
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            margin: "auto",
                          }}
                        >
                          NGUỒN ỨNG VIÊN
                        </p>
                        <div
                          style={{
                            background: "black",
                            width: "90%",
                            height: 5,
                          }}
                        ></div>
                      </Col>
                      <Col span={16} style={{ margin: "auto" }}>
                        <div
                          style={{
                            background: "black",
                            width: "100%",
                            height: 2,
                          }}
                        ></div>
                      </Col>
                      <Col span={23}>
                        <Form.Item
                          name="candidate_source"
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Vui lòng chọn nguồn ứng viên!",
                          //   },
                          // ]}
                          wrapperCol={{ span: 24 }}
                        >
                          <Radio.Group
                            // onChange={onChange}
                            // value={value}
                            style={{ marginTop: 10, width: "100%" }}
                          >
                            {listCandidateSource.map((item, index) => (
                              <Radio value={item.id}>
                                <p style={{ fontSize: 16 }}>{item.name}</p>
                              </Radio>
                            ))}
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12} style={{ marginTop: 20 }}>
                    <Row style={{ display: "flex" }}>
                      <Col span={7}>
                        <p
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            margin: "auto",
                          }}
                        >
                          CHUYÊN NGÀNH
                        </p>
                        <div
                          style={{
                            background: "black",
                            width: "90%",
                            height: 5,
                          }}
                        ></div>
                      </Col>
                      <Col span={16} style={{ margin: "auto" }}>
                        <div
                          style={{
                            background: "black",
                            width: "100%",
                            height: 2,
                          }}
                        ></div>
                      </Col>
                      <Col
                        span={23}
                        style={{ marginTop: 10 }}
                        className="form-item-col-create-cv"
                      >
                        {/* <Col span={24}>
                    <Form.Item
                      name="education_major"
                      rules={[
                        {
                          required: true,
                          message: "Vui lòng nhập chuyên ngành!",
                        },
                      ]}
                      wrapperCol={{ span: 22 }}
                    >
                      <Input
                        className="input-right-create-cv"
                        placeholder="Kỹ sư phần mềm"
                      />
                    </Form.Item>
                  </Col> */}

                        <Form.Item
                          label={
                            <MdCastForEducation className="icon-right-create-cv" />
                          }
                          name="education_major"
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 10 }}
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập chuyên ngành!",
                            },
                            {
                              pattern:
                                /^[a-zA-ZÀ-ỹ0-9]+(?:\s[a-zA-ZÀ-ỹ0-9]+)*$/,
                              message: "Ký tự không hợp lệ.",
                            },
                            {
                              min: 2,
                              message: "Chuyên ngành phải có ít nhất 2 ký tự!",
                            },
                          ]}
                        >
                          <Input
                            className="input-right-create-cv"
                            placeholder="Kỹ sư phần mềm"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12} style={{ marginTop: 20 }}>
                    <Row style={{ display: "flex" }}>
                      <Col span={7}>
                        <p
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            margin: "auto",
                          }}
                        >
                          NGÀY ỨNG TUYỂN
                        </p>
                        <div
                          style={{
                            background: "black",
                            width: "90%",
                            height: 5,
                          }}
                        ></div>
                      </Col>
                      <Col span={16} style={{ margin: "auto" }}>
                        <div
                          style={{
                            background: "black",
                            width: "100%",
                            height: 2,
                          }}
                        ></div>
                      </Col>
                      <Col
                        span={23}
                        style={{ marginTop: 10 }}
                        className="form-item-col-create-cv"
                      >
                        <Form.Item
                          label={
                            <MdDateRange className="icon-right-create-cv" />
                          }
                          name="application_date"
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 8 }}
                        >
                          <DatePicker
                            suffixIcon={null}
                            placeholder="Ngày làm việc"
                            className="date-picker-right-create-cv"
                            clearIcon
                            format={"YYYY-MM-DD"}
                            // onChange={onChange}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12} style={{ marginTop: 20 }}>
                    <Row style={{ display: "flex" }}>
                      <Col span={9}>
                        <p
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            margin: "auto",
                          }}
                        >
                          TRÌNH ĐỘ NGOẠI NGỮ
                        </p>
                        <div
                          style={{
                            background: "black",
                            width: "90%",
                            height: 5,
                          }}
                        ></div>
                      </Col>
                      <Col span={14} style={{ margin: "auto" }}>
                        <div
                          style={{
                            background: "black",
                            width: "100%",
                            height: 2,
                          }}
                        ></div>
                      </Col>
                      <Col
                        span={23}
                        style={{ marginTop: 10 }}
                        className="form-item-col-create-cv"
                      >
                        <Form.Item
                          label={
                            <MdOutlineLanguage className="icon-right-create-cv" />
                          }
                          name="language_skill"
                          labelCol={{ span: 2 }}
                          wrapperCol={{ span: 14 }}
                        >
                          <Input
                            placeholder="Tiếng Anh, Tiếng Nhật N1,..."
                            className="input-right-create-cv"
                          />
                          {/* <Select
                        onChange={handleChangeCity}
                        allowClear={true}
                        suffixIcon={null}
                        className="select-address-right-create-cv"
                        showSearch={false}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {listLanguageSkill.map((item) => (
                          <Select.Option key={item.id} value={item.name}>
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select> */}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12} style={{ marginTop: 20 }}>
                    <Row style={{ display: "flex" }}>
                      <Col span={6}>
                        <p
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            margin: "auto",
                          }}
                        >
                          TẢI LÊN FILE CV
                        </p>
                        <div
                          style={{
                            background: "black",
                            width: "90%",
                            height: 5,
                          }}
                        ></div>
                      </Col>
                      <Col span={17} style={{ margin: "auto" }}>
                        <div
                          style={{
                            background: "black",
                            width: "100%",
                            height: 2,
                          }}
                        ></div>
                      </Col>
                      <Col span={23} style={{ marginTop: 10 }}>
                        <Form.Item
                          name="upload_file"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng tải file cv!",
                            },
                          ]}
                          wrapperCol={{ span: 22 }}
                        >
                          <Upload
                            accept=".doc, .docx, .pdf"
                            fileList={selectedFileOtherList}
                            onChange={handleChangeOther}
                            beforeUpload={(file, FileList) => {
                              const checkSize = file.size / 1024 / 1024 > 10;
                              if (checkSize) {
                                openNotificationWithIcon(
                                  "error",
                                  "Lỗi",
                                  `File CV đã quá 10MB !`
                                );
                              }

                              return !checkSize ? false : Upload.LIST_IGNORE;
                            }}
                          >
                            <Button
                              icon={<FaUpload />}
                              htmlType="button"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <p style={{ marginLeft: 5 }}>Nhấn để chọn file</p>
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div style={{ textAlign: "center", marginTop: 20 }}>
                  <Button id="btn-submit" type="primary" htmlType="submit">
                    NỘP CV
                  </Button>
                </div>
              </Form>
            </div>
          )}

        {isCheckStatusSuccess === true && <FormSuccess />}

        {isCheckStatusError === true && <FormError msg={msgError} />}
      </Spin>
    </>
  );
};

export default index;
